var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('cabinet-header'),_c('section',{staticClass:"new_order"},[_c('order-info',{on:{"changePayType":function($event){_vm.pay_type = $event}}}),_c('order-products',{attrs:{"pay_type":_vm.pay_type}}),_c('div',{staticClass:"container has_table"},[_c('add-order-item')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }